module.exports = __webpack_public_path__ + "img/组5111@2x.cc25311a.png";